export default __webpack_public_path__ + "static/Romie-Black-60ad3c430f9799233e996db10aa753f3.woff";